const tables = [
  {
    name: "Number",
  },
  {
    name: "Supplier",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Delivery",
  },
  {
    name: "Payment",
  },
  {
    name: "Paid",
  },
  {
    name: "Unpaid",
  },
  {
    name: "Amount",
  },
  {
    name: "Mode",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
